var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{ref:"fileInput",staticStyle:{"display":"none"},attrs:{"type":"file","multiple":""},on:{"change":_vm.handleFiles}}),_c('div',{on:{"click":function($event){return _vm.$refs.fileInput.click()}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }